<template>
  <div>
    <div
      class="charts-container"
      ref="chart"
      v-if="chartData.length > 0"
      :style="containerStyleModifiers"
    ></div>
    <div class="charts-container__no-data" v-else-if="chartDataLoaded">No data to display</div>
  </div>
</template>

<script src="./container.js"></script>
<style src="./container.scss" lang="scss"></style>
